import React, { useState } from "react";
import {
    Heading,
    TabNavigation,
    TabNavigationItem
} from "@livingdesign/react";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { getTabList } from "../../helpers/utils";
import { TAB_LABEL } from "../../constants/tabLabel";
import AFAPortfolioList from "../Organization/AFA/AFAPortfolioList/AFAPortfolioList";
import MatterStyles from "./Matters.styles";
import MatterList from "./Listing/MatterList";

/**
 * FinancialList component - It will use for displaying the overview of financial
 * alongside with Budgets, Invoices and workflows
 *
 */
const Matters = () => {
    const classes = MatterStyles();
    const matterAccessibility = useSelector((state) => state?.accessibility?.applicationAccess?.matters);
    const { listOfTabs, tabIndexMap } = getTabList(matterAccessibility);
    const { state: { currentFinancialTab: currentTab } = {} } = useLocation();
    const [isCurrent, setIsCurrent] = useState(currentTab || tabIndexMap[listOfTabs[0]]);

    const tabContent = () => {
        switch (isCurrent) {
            case tabIndexMap[TAB_LABEL.MATTERS]:
                return <MatterList />
            case tabIndexMap[TAB_LABEL.PORTFOLIO]:
                return <AFAPortfolioList />
            default:
                return null;
        }
    };

    return (
        <div className={classes.financialWrapper}>
            <div className={classes.header}>
                <Heading as="h1" size="large" UNSAFE_className={classes.pageTitle}>
                    Matters
                </Heading>
            </div>
            <div className={classes.financialTabNavigation}>
                <TabNavigation>
                    {listOfTabs?.map((item, index) => (
                        <TabNavigationItem
                            data-testid={`matter-tab-${tabIndexMap[item]}`}
                            id={`matter-tab-${tabIndexMap[item]}`}
                            onClick={() => setIsCurrent(tabIndexMap[item])}
                            isCurrent={isCurrent === tabIndexMap[item]}
                            key={tabIndexMap[item]}
                        >
                            {item}
                        </TabNavigationItem>
                    ))}
                </TabNavigation>
            </div>
            <div data-testid="matter-content" id='tab-content'>
                {tabContent()}
            </div>
        </div>
    );
};

export default Matters;
